<script lang="ts" setup>
import DispositionsAuftragBegleitfahrt from "./DispositionsAuftragBegleitfahrt.vue";
import { getFahrzeugColor } from "../utils/colors";
import { ArrowRightIcon } from "@heroicons/vue/20/solid";
import DispositionFahrerListe from "./DispositionFahrerListe.vue";
import { IBegleitfahrt, IFahrer } from "../api/useDispositionsplan";

interface IAuftrag {
  abholung: {
    name: string;
    datum: string | null;
  };
  anlieferung: {
    name: string;
  };
  fahrzeug: {
    fahrzeugtyp: string;
    fahrer: IFahrer[];
  };
  begleitfahrten: IBegleitfahrt[];
}

defineProps<{ auftrag: IAuftrag }>();
</script>

<template>
  <div class="whitespace-normal">
    <div class="block w-full px-4 py-2 bg-white shadow-md print:shadow-none">
      <div class="flex items-center space-x-4 leading-tight">
        <div>
          <span class="block font-medium tracking-wide text-gray-800">
            {{ auftrag.abholung.name }}
          </span>
        </div>
        <div>
          <ArrowRightIcon class="w-5 h-5 text-gray-800" />
        </div>
        <div>
          <span class="block font-medium tracking-wide text-gray-800">
            {{ auftrag.anlieferung.name }}
          </span>
        </div>
      </div>
      <div class="text-gray-800">
        <div
          class="block max-w-full"
          :class="getFahrzeugColor(auftrag.fahrzeug.fahrzeugtyp)"
        >
          <DispositionFahrerListe :fahrer="auftrag.fahrzeug.fahrer" />
        </div>
      </div>
      <div v-for="(begleitfahrt, index) in auftrag.begleitfahrten" :key="index">
        <div
          class="flex items-center justify-between space-x-4 text-xs leading-tight"
          :style="{
            color: begleitfahrt.typ.schriftfarbe,
            backgroundColor: begleitfahrt.typ.hintergrundfarbe,
          }"
        >
          <DispositionsAuftragBegleitfahrt
            :begleitfahrt="begleitfahrt"
            :auftrag-von-datum="auftrag.abholung.datum"
          />
        </div>
      </div>
    </div>
  </div>
</template>
